import React, { useEffect } from "react";
import { X } from "lucide-react";
import FileViewer from "./FileViewer";

export default function FileModal({ file, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!file) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/90 p-4 backdrop-blur-sm" data-testid="file-modal" onClick={onClose}>
      <div className="max-h-[90vh] w-full max-w-4xl overflow-auto border border-edge bg-ink" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-edge px-6 py-4">
          <div>
            <h3 className="font-serif text-2xl text-bone">{file.title}</h3>
            {file.category && <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-gold">{file.category}</p>}
          </div>
          <button onClick={onClose} data-testid="file-modal-close" className="text-muted hover:text-gold">
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="p-6">
          <FileViewer file={file} />
          {file.description && <p className="mt-4 text-sm leading-relaxed text-[#cfc9bd]">{file.description}</p>}
        </div>
      </div>
    </div>
  );
}
